/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_CancelInputs */

const en_my_payments_cancel = /** @type {(inputs: My_Payments_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel at period end`)
};

const pl_my_payments_cancel = /** @type {(inputs: My_Payments_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj z końcem okresu`)
};

/**
* | output |
* | --- |
* | "Cancel at period end" |
*
* @param {My_Payments_CancelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_cancel = /** @type {((inputs?: My_Payments_CancelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_CancelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_cancel(inputs)
	return en_my_payments_cancel(inputs)
});